import V from 'voUtils/V.js';
import MarkerClusterer from 'voUtils/MarkerClusterer.js';
import {
	debounce
}
from 'voUtils/tools.js';

import {
	loadGmaps
}
from 'voUtils/loader.js';


function pinSymbol(color) {
	return {
		path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z',
		fillColor: color,
		fillOpacity: 1,
		strokeColor: '#000',
		strokeWeight: 1,
		scale: 1.2
	};
}

const DEFAULT_MARKER_COLOR = '#3548a1';


export default {
	voVueComponent: 'voffice-gmap',
	data() {
		return {
			openstreetmap: false,
			openstreetconsent: false,
			markers: [],
			lazyUpdateMarkers: false,
			lazyUpdateSingleMarker: false,
			map: null
		};
	},
	template: `
<div>
	<div v-if="openstreetmap">
      <div class="mapnote">
          {{voMsg('google.map.note1')}}
          <voffice-doc-box doc-id="privacy">
              <a class="footer-link"
                  href="">{{voMsg('google.map.note.datenschutz')}}</a>
          </voffice-doc-box> {{voMsg('google.map.note2')}}
          <div v-if="!openstreetconsent"><a href=""
              @click.prevent="removeConsent()">{{voMsg('google.map.note.prevent')}}</a>
			 </div>
			 <div v-if="openstreetconsent"><a href="javascript:CCM.openControlPanel()">
             {{voMsg('google.map.note.prevent')}}</a>
			</div>
      </div>
     <div ref="slot">
        <slot></slot>
     </div>
     <div style="width:100%;height:100%" ref="map">
     </div>
	</div>
	<div v-else>
      <div class="mapconsent">
        <p>{{voMsg('google.map.consent.note1')}}
    <br>{{voMsg('google.map.consent.note2')}}</p>
    <voffice-doc-box doc-id="privacy">
        <a class="footer-link mapconsent-button"
            href="">{{voMsg('google.map.note.datenschutz')}}</a>
    </voffice-doc-box>
    <br><a href="javascript:CCM.openControlPanel()" class="mapconsent-button">
        {{voMsg('google.map.allow.link')}}</a>
       </div>
	</div>
</div>
`,
	props: {
		items: Array,
		initialPos: Array,
		initialZoom: Number,
		mapType: String,
		scrollok: Boolean,
		draggable: String,
		highlight: Number,
		selected: Object,
		markerPos: Array,
		cluster: Boolean
	},
	created: function () {

		var vc = this;
		this.onMarkerClicked = function () {
			vc.$emit('update:selected', this.customData);
		};

		var onResize = debounce(() => {
			this.updateBounds();
		}, 800);
		window.addEventListener("resize", onResize);

	},
	beforeMount: function () {
		this.checkOsmConsent();
	},
	mounted: function () {

		console.log('[GMAP] mounted');

		window.addEventListener('ccm19WidgetClosed', (event) => {
			//console.log('[GMAP] consent changed');
			this.checkOsmConsent();
		});

		if (this.openstreetmap) {
			//console.log('[GMAP] calling initMap from mounted');
			this.initMap();
		}

	},

	methods: {
		initMap: function () {
			const initialPos = this.initialPos || this.markerPos || [10, 54];
			const initialZoom = this.initialZoom || 5;

			//console.log('[GMAP] initMap START');

			loadGmaps(() => {

				var myStyles = [{
					featureType: "poi.business",
					elementType: "labels",
					stylers: [{
						visibility: "off"
					}]
				}];


				const mapOptions = {
					clickableIcons: false,
					center: new google.maps.LatLng(initialPos[1], initialPos[0]),
					zoom: initialZoom,
					mapTypeId: google.maps.MapTypeId[this.mapType || 'ROADMAP']
				};

				if (!this.scrollok) mapOptions.scrollwheel = false;
				if (this.draggable === 'false') mapOptions.draggable = false;

				this.map = new google.maps.Map(this.$refs.map, mapOptions);
				//console.log('[GMAP] map created:', this.map);
				//console.log('[GMAP] markers BEFORE:', this.markers);

				this.infowindow = new google.maps.InfoWindow({
					content: this.$refs.slot,
					maxWidth: 320
				});


				//this.updateSingleMarker();
				this.updateMarkers();
				if (!this.items) {
					setTimeout(() => {
						//console.log('[GMAP TEST] forcing marker');
						this.updateSingleMarker();
					}, 500);

				}

				//console.log('[GMAP] initMap END');


			});
		},
		checkOsmConsent: function () {

			const data = CCM.acceptedEmbeddings;
			const targetName = "Google Maps";
			const entry = data.find(item => item.name === targetName);

			if (entry) {
				this.openstreetmap = true;
				this.openstreetconsent = true;
				//console.log('Zugestimmt');
				this.$nextTick(() => {
					this.initMap();
				});
				return;
			} else {
				this.openstreetmap = false;
				this.openstreetconsent = false;
			}

			const suffix = VOFFICE.token.substr(VOFFICE.token.length - 12);
			var cookieName = 'allowOpenstreetmap_' + suffix;
			const allowOpenstreet = this.getCookie(cookieName);
			if (allowOpenstreet) {
				this.openstreetmap = true;
			}
		},

		getCookie: function (name) {
			const nameEQ = name + "=";
			const ca = document.cookie.split(';');
			for (let i = 0; i < ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) === ' ') c = c.substring(1, c.length);
				if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
			}
			return null;
		},

		setCookie: function (name, value, days) {
			const date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			const expires = "expires=" + date.toUTCString();
			document.cookie = name + "=" + value + ";" + expires + ";path=/";
		},

		deleteCookie: function (name) {

			document.cookie =
				name +
				'=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

			location.reload();

		},

		removeConsent: function () {

			const suffix =
				VOFFICE.token.substr(
					VOFFICE.token.length - 12
				);

			const cookieName =
				'allowOpenstreetmap_' + suffix;

			this.deleteCookie(cookieName);

			this.openstreetmap = false;

		},

		allowOpenstreetmap: function () {
			const suffix = VOFFICE.token.substr(VOFFICE.token.length - 12);
			var cookieName = 'allowOpenstreetmap_' + suffix;
			this.setCookie(cookieName, true, VOFFICE.settings.osmCookieDays);
			this.openstreetmap = true;

			location.reload();
		},

		showOpenstreetmap: function () {
			this.openstreetmap = true;
		},

		allowGoogleMaps: function () {
			localStorage.setItem('allowGoogleMaps', true);
			location.reload();
		},
		preventGoogleMaps: function () {
			localStorage.setItem('allowGoogleMaps', false);
			location.reload();
		},
		canShowGoogleMaps: function () {
			var GoogleMaps = localStorage.getItem("allowGoogleMaps");
			if (GoogleMaps === 'true') {
				return true;
			}
			return false;
		},
		findMarkerById: function (id) {
			if (this.markers) {
				for (let m of this.markers) {
					if (m.customData && m.customData._id == id) {
						return m;
					}
				}
			}
		},
		updateBounds: function () {
			if (this.bounds && this.markers && this.markers.length) {

				this.map.initialZoom = true;
				this.map.fitBounds(this.bounds);
			}
		},
		deleteMarkers: function () {
			if (this.markers) {

				if (this.clusterer) {
					this.clusterer.removeMarkers(this.markers);
				}


				for (let m of this.markers) {
					m.setMap(null);
				}
			}

			this.markers = [];

		},

		updateSingleMarker: function () {

			/*console.log('[GMAP] updateSingleMarker', {
				map: !!this.map,
				markerPos: this.markerPos
			});*/

			if (!this.map) {
				console.warn('[GMAP] map not ready → abort');
				return;
			}

			if (this.map) {


				this.deleteMarkers();

				if (this.markerPos) {
					let latlng = new google.maps.LatLng(this.markerPos[1], this.markerPos[0]);

					let markerOptions = {
						position: latlng,
						map: this.map,
						draggable: false
					};





					let marker = new google.maps.Marker(markerOptions);

					//console.log('marker::', marker);
					this.markers.push(marker);

					//console.log('markers::', this.markers);
				}

			} else {
				this.lazyUpdateSingleMarker = true;
			}

		},

		updateMarkers: function () {

			if (!this.map) {
				//console.warn('[GMAP] map not ready → abort');
				return;
			}

			if (this.map) {

				this.deleteMarkers();

				V.log("gmap items", this.items);

				if (this.items) {
					this.bounds = new google.maps.LatLngBounds();

					for (let item of this.items) {
						let markerOptions;

						if (item.loc) {
							let latlng = new google.maps.LatLng(item.loc.coordinates[1], item.loc.coordinates[0]);

							markerOptions = {
								position: latlng,
								icon: pinSymbol(DEFAULT_MARKER_COLOR),
								draggable: false,
								customData: item
							};

						} else if (Array.isArray(item)) {
							//array result
							let latlng = new google.maps.LatLng(item[1], item[0]);

							markerOptions = {
								position: latlng,
								icon: pinSymbol(DEFAULT_MARKER_COLOR),
								draggable: false,
								customData: {
									_id: item[2],
									lazy: true,
									info: item
								}
							};
						}

						if (markerOptions) {


							if (!this.cluster) {
								markerOptions.map = this.map;
							}

							let marker = new google.maps.Marker(markerOptions);

							marker.addListener('click', this.onMarkerClicked);
							this.markers.push(marker);
							this.bounds.extend(marker.getPosition());

						}

					}

					this.updateBounds();

					if (this.cluster) {
						if (this.clusterer) {
							this.clusterer.addMarkers(this.markers);
						} else {
							this.clusterer = new MarkerClusterer(this.map, this.markers, {
								imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
								maxZoom: 15
							});
						}
					}

				}

			} else {
				this.lazyUpdateMarkers = true;
			}

		},
		unHighlightMarker: function (m) {
			if (this.highlightedMarker) {
				m.setAnimation(null);
				m.setIcon(pinSymbol(DEFAULT_MARKER_COLOR));
				m.setZIndex(m._zIndex);

				this.highlightedMarker = undefined;
			}
		},
		highlightMarker: function (m) {
			m.setAnimation(google.maps.Animation.BOUNCE);
			m.setIcon(pinSymbol('red'));

			m._zIndex = m.getZIndex();
			m.setZIndex(2000);
			this.highlightedMarker = m;
			setTimeout(() => {
				m.setAnimation(null);
			}, 750);
		}
	},
	watch: {
		markerPos: function () {
			if (!this.map) return;

			this.updateSingleMarker();
		},
		items: {
			deep: true,
			handler: function (nv) {
				this.updateMarkers();
			}
		},
		highlight: function (id) {

			if (this.selected && this.selected._id) {
				return;
			}

			this.updateBounds();

			this.unHighlightMarker(this.highlightedMarker);

			if (id) {
				let m = this.findMarkerById(id);
				if (m) {
					this.highlightMarker(m);

				}
			}
		},
		selected: function (nv) {
			this.unHighlightMarker(this.highlightedMarker);
			if (!this.cluster) {
				this.updateBounds();
			}

			var m = this.findMarkerById(nv._id);
			if (m) {
				this.infowindow.open(this.map, m);
				this.highlightMarker(m);
			} else {
				this.infowindow.close();
			}

		}

	}
};